declare const DEBUG:boolean;

export class BootstrapService {
	public appType:string = 'sharebase-app';

	constructor(
		appType:string
	){
		if (!DEBUG && window !== window.top) {
			let errMsg = 'Application may not be externally hosted.';
			document.documentElement.innerHTML = errMsg;
			throw new Error(errMsg);
		}

		this.appType = appType;
	}

	private getSettings() {
		let injector = angular.injector(['ng']);
		let $http = injector.get('$http');
			
		return $http
			.get('settings.json')
			.then(res => {
				angular
					.module('site.settings')
					.constant('SITE_SETTINGS', res.data);
				return res.data;
			});		
	}
	
	public bootstrapApp() {
		return this.loadAppAsync()
			// manually bootstrap app once translations are determined.
			.then((resolvedLang:any) => {
				let bootstrapInjector = angular.injector(['ng', 'ngLocale']);
				
				/* we create a new module 
				*		- config block to generate MD themes on app load
				*		- run block to set the resolved language/strings
				*		- depend on original auto bootstrap module - sharebase-app or sharebase-app-admin
				*/
				angular.module('asyncAppLoader',[ this.appType ])
					.config([
						'$mdThemingProvider',
						'$mdDateLocaleProvider',
						(
							$mdThemingProvider,
							$mdDateLocaleProvider
						) => {						
							//seems mdThemes are not generated during manual bootstrap, so allow themes to be generated after config block
							$mdThemingProvider.generateThemesOnDemand(true);
							let $date = bootstrapInjector.get('$filter')('date');
			
							$mdDateLocaleProvider.formatDate = date => $date(date, 'shortDate');
					}])
					.run([
						'gettextCatalog',
						'pxEnvironmentService',
						(
							gettextCatalog,
							pxEnvironmentService
						) => {
							//set resolved language
							if(resolvedLang){
								gettextCatalog.setCurrentLanguage(resolvedLang.lang);
								gettextCatalog.strings = resolvedLang.strings;
								pxEnvironmentService.legalLanguage =  resolvedLang.legalLang;
								pxEnvironmentService.helpLanguage = resolvedLang.helpLang; 
								document.title = this.appType === 'sharebase-app-admin' ? 
								gettextCatalog.getString('Administration - ShareBase by Hyland') :
								gettextCatalog.getString('ShareBase by Hyland');
							}
					}]);
		
				//now bootstrap app
				angular.element(document).ready(() => {
					angular.bootstrap(document, ['asyncAppLoader']);			
				});
			});
	}

	private loadAppAsync() {
		return this.getSettings()
			.then(() => {
				let injector = angular.injector(['ng', 'site.settings', 'gettext']);
				let $q:ng.IQService = injector.get('$q');
				let $http:ng.IHttpService = injector.get('$http');
				let settingsService:any = injector.get('settingsService');
				let gettextCatalog:any = injector.get('gettextCatalog');
		
				return $http.get(settingsService.serverAPIPath + '/languages')
					.then((response:any) => {
						return {
							language: response.data.useLangFile,
							locale: response.data.useLang
						};
					})
					.catch(() => {
						return {
							language: 'en',
							locale: 'en'
						};
					})
					.then(lang => {
						let language = lang.language.toLowerCase();
						let defaultLang = { language: 'en', locale: 'en' };
		
						if (language === 'en' || language === 'en-us') {
							return defaultLang;
						}
		
						return gettextCatalog.loadRemote('lang/' + language + '.json')
							.then(() => lang)
							.catch(() => defaultLang);
					})
					.then(lang => {
						let language = lang.language;
						gettextCatalog.setCurrentLanguage(language);
		
						let tosPath = '/terms-of-service/index.htm';
						if (language !== 'en') {
							tosPath = '/' + language + tosPath;
						}
						let helpPath = language === 'en' ?
							settingsService.serverHelpPath :
							settingsService.serverHelpPath.replace('/help/', '/help/' + language + '/');
		
						return $q.all([
							$http.head(settingsService.serverLegalPath + tosPath)
								.then(() => language)
								.catch(() => $q.resolve('en')),
		
							$http.head(helpPath)
								.then(() => language)
								.catch(() => $q.resolve('en'))
						])
						.then(results => {
							return {
								lang: gettextCatalog.currentLanguage,
								legalLang: results[0],
								strings: gettextCatalog.strings,
								helpLang: results[1],
								locale: lang.locale
							};
						});
					})
					.then(this.loadNgLocale);
			});
			
	}

	private loadNgLocale(lang) {
		let injector = angular.injector(['ng']);
		let $q = injector.get('$q');

		return $q((resolve, reject) => {
			let url = 'lang/angular/angular-locale_' + lang.locale + '.js';
			let script = document.createElement('script');
			script.src = url;
			script.onload = () => {
				resolve(lang);
			};

			script.onerror = e => {
				if (DEBUG) {
					console.warn('Failed to load local script: ' + url);
					console.error(e);
				}
				// Rejecting here will cause the app to fail. Just resolve
				// with the provided language.
				resolve(lang);
			};

			document.body.appendChild(script);
		});
	}

}



// WEBPACK FOOTER //
// ./src/util/services/bootstrapService.ts